<template>
    <div class="box">
        <div class="title">当前报警设备</div>
        <div class="content"><scrollable-table :columns="tableColumns" :rows="tableRows" @handleClick="handleClick" />
        </div>
        <devicedeatil v-if="deviceDeatilShow" :deviceData="checkDeviceDetail" @close="deviceDeatilShow = false">
        </devicedeatil>
        <msLoading ref="loading"></msLoading>
    </div>
</template>

<script>
import msLoading from '@/components/common/msLoading.vue';
import ScrollableTable from '../ScrollableTable.vue';
import devicedeatil from '@/components/common/maxWeb/devicedeatil.vue';
import { mapGetters } from 'vuex';
export default {
    name: 'rightcard1',
    data() {
        return {
            checkDeviceDetail: null,
            deviceDeatilShow: false,
            tableColumns: ['设备名称', '报警时间', '报警类型'],
            tableRows: []
        };
    },
    components: {
        ScrollableTable,
        devicedeatil,
        msLoading
    },
    computed: {
        ...mapGetters(['getNewDeviceMessage'])
    },
    mounted() {
        this.$refs.loading.show();
        this.tableRows = this.$store.state.deviceMessage;
        console.log('this.tableRows');
        console.log(this.tableRows);
        this.$refs.loading.hide();
    },
    watch: {
        getNewDeviceMessage() {
            console.log('rightcard2执行');
            this.tableRows = this.getNewDeviceMessage;
        }
    },
    methods: {
        handleClick(e) {
            this.deviceDeatilShow = true;
            // 打开设备详情页面
            this.checkDeviceDetail = e.deviceData;
        }
    }
};
</script>

<style lang="less" scoped>
.box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    padding: 0.2rem;
    position: relative;

    .title {
        color: aqua;
        font-size: 0.4rem;
        box-sizing: border-box;
        font-weight: bold;
    }

    .content {
        box-sizing: border-box;
        font-size: 0.2rem;
        color: #fff;
    }

    .content::-webkit-scrollbar {
        width: 0;
        height: 0;
    }
}
</style>